import React, {createContext} from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import UsersStore from "./store/UsersStore";
import ThingsStore from "./store/ThingsStore";
import MessagesStore from "./store/MessagesStore";
import ChannelStore from "./store/ChannelStore";
import UIStore from "./store/UI";
import CertStore from "./store/CertStore";
import {render} from "react-dom";
import AnalyticsStore from "./store/AnalyticsStore";

export const Context = createContext(null)
// const root = ReactDOM.createRoot(document.getElementById('root'));
render(
    <React.StrictMode>
        <Context.Provider value={{
            user: new UsersStore(),
            things: new ThingsStore(),
            messages: new MessagesStore(),
            channels: new ChannelStore(),
            ui: new UIStore(),
            cert: new CertStore(),
            analytics: new AnalyticsStore(),
        }}>
            <App/>
        </Context.Provider>
    </React.StrictMode>,
    document.getElementById('root')
);
